<div class="cx-one-ui">
    <!-- header -->
    <div class="modal-header cxone-modal-header">
        <div cvLocalizedText langSection="CXOne_Modal" langKey="Thresholds">Thresholds</div>
        <div class="modal-close">
            <button type="button" class="icon-btn fill-iconDefault" (click)="cancel()">
                <svg class="icon-12"><use href="../../App_Themes/CXone/icons/close.svg#close"></use></svg>
            </button>
        </div>   
    </div> 
    <div class="modal-body cxone-modal-body cxms-loader-holder p-0 position-relative " *ngIf="isLoading">
        <cv-loader size="medium" [overlay]="false"></cv-loader>
    </div>

    <!-- body -->
    <div class="modal-body cxone-modal-body" [hidden]="isLoading">
        <div class="select-metrics-label">
            <label cvLocalizedText langSection="CXOne_Modal" langKey="Select_Metrics">Select Metrics</label>
            <cv-multi-select
                class="group-selector-body flex-fill d-flex flex-column"
                [options]="metrics"
                [value]="selectedMetrics"
                (valueChange)="onSelectionChanged($event)"
                primaryKey="Id" label="Name"
                (opened)="onSelectorOpened()"
                (closed)="onSelectorClosed()"
            ></cv-multi-select>
        </div>


        <div *ngIf="!selectedMetrics || selectedMetrics.length < 1" class="metrics-body empty-message">
            <svg class="empty-error-icon"><use href="../App_Themes/CXone/icons/empty.svg#empty"></use></svg>
            <span class="metric-text" cvLocalizedText langSection="CXOne_Modal" langKey="No_Metric_Message">No metrics selected yet</span>
        </div>
        <form #thresholdsForm="ngForm" class="metrics-body" style="overflow-y: auto" [ngStyle]="{'height': selectedMetrics && selectedMetrics.length > 0 ? '100%' : '0px'}">
            <div *ngIf="selectedMetrics && selectedMetrics.length > 0" >
                <div *ngFor="let metric of selectedMetrics">
                    <div class="item-header">
                        <div class="item-labels">
                            <div class="metric-name">{{metricNames.get(metric.toString())}}</div>
                            <div class="select-text" cvLocalizedText langSection="CXOne_Modal" langKey="Set_Values">Set the values for each range for the Metric</div>
                        </div>
                        <div>
                            <button type="button" class="delete-button btn btn-icon fill-iconDefault" (click)="deselectMetric(metric.toString())">
                                <svg class="icon-12"><use href="../App_Themes/CXone/icons/delete.svg#delete"></use></svg>
                            </button>
                        </div>
                    </div>
                    <div ngModelGroup="metricThresholds[{{metric}}]" #thresholdForm="ngModelGroup" class="thresholds-container" thresholdRange>
                        <cxone-checkbox name="topEnabled" type="checkbox" [(ngModel)]="metricThresholds[metric][0].enabled"></cxone-checkbox>
                        <span class="dot" [ngClass]="[getDirection(metric) ? 'dot-green' : 'dot-red', !metricThresholds[metric][0].enabled ? 'disabled-color' : '']"></span>
                        <cxone-text-input name="topValue" [ngModel]="metricThresholds[metric][0].left" [disabled]="!metricThresholds[metric][0].enabled"
                            (ngModelChange)="cleanTextInput($event, metric, 0, 0)"
                            [ngClass]="metricThresholds[metric][0].enabled && thresholdForm.errors?.top ? 'range-error' : ''">
                        </cxone-text-input>
                        <span></span>
                        <span class="limit-text" cvLocalizedText langSection="CXOne_Modal" langKey="And_Up">and up</span>

                        <cxone-checkbox name="middleEnabled" type="checkbox" [(ngModel)]="metricThresholds[metric][1].enabled"></cxone-checkbox>
                        <span class="dot dot-yellow" [ngClass]="!metricThresholds[metric][1].enabled ? 'disabled-color' : ''"></span>
                        <cxone-text-input name="middleLeftValue" [ngModel]="metricThresholds[metric][1].left" [disabled]="!metricThresholds[metric][1].enabled"
                            (ngModelChange)="cleanTextInput($event, metric, 1, 0)"
                            [ngClass]="metricThresholds[metric][1].enabled && thresholdForm.errors?.middleLeft ? 'range-error' : ''">
                        </cxone-text-input>
                        <div cvLocalizedText langSection="CXOne_Modal" langKey="To" class="to-text">To</div>
                        <cxone-text-input name="middleRightValue" [ngModel]="metricThresholds[metric][1].right" [disabled]="!metricThresholds[metric][1].enabled"
                            (ngModelChange)="cleanTextInput($event, metric, 1, 1)"
                            [ngClass]="metricThresholds[metric][1].enabled && thresholdForm.errors?.middleRight ? 'range-error' : ''">
                        </cxone-text-input>

                        <cxone-checkbox name="bottomEnabled" type="checkbox" [(ngModel)]="metricThresholds[metric][2].enabled"></cxone-checkbox>
                        <span class="dot" [ngClass]="[getDirection(metric) ? 'dot-red' : 'dot-green', !metricThresholds[metric][2].enabled ? 'disabled-color' : '']"></span>
                        <cxone-text-input name="bottomValue" [ngModel]="metricThresholds[metric][2].right" [disabled]="!metricThresholds[metric][2].enabled"
                            (ngModelChange)="cleanTextInput($event, metric, 2, 1)"
                            [ngClass]="metricThresholds[metric][2].enabled && thresholdForm.errors?.bottom ? 'range-error' : ''">
                        </cxone-text-input>
                        <span></span>
                        <span class="limit-text" cvLocalizedText langSection="CXOne_Modal" langKey="And_Below">and below</span>
                    </div>  
                    <span *ngIf="!thresholdForm.errors?.range" class="range-conflict"></span>
                    <span *ngIf="thresholdForm.errors?.range" class="range-conflict" cvLocalizedText langSection="CXOne_Modal" langKey="Value_Conflict">
                        There is a conflict between the highlighted values
                    </span>
                </div>
            </div>
        </form>
    </div>  

    <!-- footer -->
    <div class="modal-footer cxone-modal-footer">
        <button class="btn btn-secondary modal-footer-btn ml-auto" (click)="cancel()" cvLocalizedText langSection="CXOne_Modal" langKey="Cancel">
            Cancel
        </button>
        <button class="btn btn-primary modal-footer-btn ml-2" (click)="save()" cvLocalizedText langSection="Common" langKey="Apply"
            [disabled]="thresholdsForm?.invalid">
            Apply
        </button>
    </div> 
</div>
